export const ibanJurisdictions = [
  "FIAT_AE",
  "FIAT_CH",
  "FIAT_BR",
  "FIAT_SA",
  "FIAT_EG",
  "FIAT_GT",
  "FIAT_QA",
  "FIAT_BH",
  "FIAT_CR",
  "FIAT_TR",
  "FIAT_GL",
  "FIAT_PL",
  "FIAT_GB",
  "FIAT_EU",
];

export const accountNumberJurisdictions = [
  "FIAT_HK",
  "FIAT_SG",
  "FIAT_CN",
  "FIAT_PA",
  "FIAT_MY",
  "FIAT_JP",
  "FIAT_BS",
  "FIAT_IN",
  "FIAT_CA",
  "FIAT_US",
];

export const clabeJurisdictions = ["FIAT_MX"];

export const allJurisdictions = [
  "FIAT_US",
  ...clabeJurisdictions,
  ...ibanJurisdictions,
  ...accountNumberJurisdictions,
];
